/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { NotePdfOptions } from "../model"
// @ts-ignore
import type { PdfLink } from "../model"
// @ts-ignore
import type { PdfMementoV2 } from "../model"
// @ts-ignore
import type { PdfNoteDataV2 } from "../model"
/**
 * PdfResourceV2Api - axios parameter creator
 */
export const PdfResourceV2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Generate PDF V2 link for note
     * @param {number} projectId
     * @param {NotePdfOptions} notePdfOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePdf: async (
      projectId: number,
      notePdfOptions: NotePdfOptions,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("generatePdf", "projectId", projectId)
      // verify required parameter 'notePdfOptions' is not null or undefined
      assertParamExists("generatePdf", "notePdfOptions", notePdfOptions)
      const localVarPath = `/v2.0/api/pdf/note/{projectId}`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        notePdfOptions,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get note\'s PDF V2 data by note id
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNoteData: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getNoteData", "projectId", projectId)
      const localVarPath = `/v2.0/api/pdf/{projectId}/data`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get note\'s memento PDF V2 data by note id
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPdfMementoDataV2: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getPdfMementoDataV2", "projectId", projectId)
      const localVarPath = `/v2.0/api/pdf/{projectId}/mementoData`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PdfResourceV2Api - functional programming interface
 */
export const PdfResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PdfResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Generate PDF V2 link for note
     * @param {number} projectId
     * @param {NotePdfOptions} notePdfOptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generatePdf(
      projectId: number,
      notePdfOptions: NotePdfOptions,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfLink>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.generatePdf(
        projectId,
        notePdfOptions,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PdfResourceV2Api.generatePdf"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get note\'s PDF V2 data by note id
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNoteData(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfNoteDataV2>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getNoteData(projectId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PdfResourceV2Api.getNoteData"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get note\'s memento PDF V2 data by note id
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPdfMementoDataV2(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfMementoV2>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPdfMementoDataV2(
        projectId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["PdfResourceV2Api.getPdfMementoDataV2"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * PdfResourceV2Api - factory interface
 */
export const PdfResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PdfResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Generate PDF V2 link for note
     * @param {PdfResourceV2ApiGeneratePdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePdf(
      requestParameters: PdfResourceV2ApiGeneratePdfRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PdfLink> {
      return localVarFp
        .generatePdf(requestParameters.projectId, requestParameters.notePdfOptions, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get note\'s PDF V2 data by note id
     * @param {PdfResourceV2ApiGetNoteDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNoteData(
      requestParameters: PdfResourceV2ApiGetNoteDataRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PdfNoteDataV2> {
      return localVarFp
        .getNoteData(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get note\'s memento PDF V2 data by note id
     * @param {PdfResourceV2ApiGetPdfMementoDataV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPdfMementoDataV2(
      requestParameters: PdfResourceV2ApiGetPdfMementoDataV2Request,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PdfMementoV2> {
      return localVarFp
        .getPdfMementoDataV2(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for generatePdf operation in PdfResourceV2Api.
 */
export interface PdfResourceV2ApiGeneratePdfRequest {
  readonly projectId: number

  readonly notePdfOptions: NotePdfOptions
}

/**
 * Request parameters for getNoteData operation in PdfResourceV2Api.
 */
export interface PdfResourceV2ApiGetNoteDataRequest {
  readonly projectId: number
}

/**
 * Request parameters for getPdfMementoDataV2 operation in PdfResourceV2Api.
 */
export interface PdfResourceV2ApiGetPdfMementoDataV2Request {
  readonly projectId: number
}

/**
 * PdfResourceV2Api - object-oriented interface
 */
export class PdfResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Generate PDF V2 link for note
   * @param {PdfResourceV2ApiGeneratePdfRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public generatePdf(
    requestParameters: PdfResourceV2ApiGeneratePdfRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PdfResourceV2ApiFp(this.configuration)
      .generatePdf(requestParameters.projectId, requestParameters.notePdfOptions, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get note\'s PDF V2 data by note id
   * @param {PdfResourceV2ApiGetNoteDataRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getNoteData(
    requestParameters: PdfResourceV2ApiGetNoteDataRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PdfResourceV2ApiFp(this.configuration)
      .getNoteData(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get note\'s memento PDF V2 data by note id
   * @param {PdfResourceV2ApiGetPdfMementoDataV2Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getPdfMementoDataV2(
    requestParameters: PdfResourceV2ApiGetPdfMementoDataV2Request,
    options?: RawAxiosRequestConfig
  ) {
    return PdfResourceV2ApiFp(this.configuration)
      .getPdfMementoDataV2(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
